<template>
	<CommonLoading
		v-if="loading"
	/>
	<FilterComponent
		:title="'segurado'"
		:open="openFilter"
		:fields="filterFields"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
    />
	<Commonlisting
		:listingData = "seguradoData"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:inputsListing= "inputs"
		:previous = "previous"
		:next = "next"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:extraInputName= "extraInputName"
		:extraInputs= "extraInput"
		:resetFormData= "resetFormData"
		:editFormData= "editFormData"
		:importFile= "true"
		:fileOnly= "false"
		:selectBoxItems= "selectBoxItems"
		:useForms= "false"
		:useView="false"
		:updateFile="true"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@send-form-data= "onSendFormData"
		@delete-data-id= "deleteData"
		@send-editing-data= "updateAssociatedData"
		@edit-alternative= "getEditData"
		@upload-data= "sendImportFile"
		@filter="openFilter = true"
	/>
	<EditSegurado
		:open="isModalOpen"
		:agendadores="agendadores"
		:segurado="editFormData"
		@update-open="isModalOpen = $event"
		@save="updateAssociatedData"
		@avulso="agendamentoAvulso"
		@segurado-empresa="getEditData"
		@save-bulk= "onSaveBulk"
		@remove-item="removeItem"
		@segurado-badge="seguradoBadge"
		@remove-badge="deleteBadge"
	/>
</template>
<script>
import Commonlisting from '@/components/generalcomponents/CommonListing';
import EmpresasRepository from '@/services/EmpresasRepository.vue';
import SeguradosRepository from '@/services/SeguradosRepository.vue';
import { pageVariables } from '@/views/insideviews/segurados/PageVariablesSegurados';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import CommonLoading from '@/components/generalcomponents/CommonLoading';
import EditSegurado from '@/views/insideviews/segurados/EditSegurado.vue'
import Swal from "sweetalert2";
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import AgendamentosRepository from '@/services/AgendamentosRepository.vue';
import GruposRepository from '@/services/GruposRepository.vue';
import GeneralSeguradoEditRepository from '@/services/GeneralSeguradoEditRepository.vue';
import BadgesRepository from '@/services/BadgesRepository.vue';

export default {
	name: 'SeguradosView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.pageGetSegurados);
	},
	data() {
		return {
			...pageVariables,
			seguradoData: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			editFormData:{},
			selectBoxItems: [],
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			loading: false,
			isModalOpen : false,
			openFilter: false,
			filters: [],
			agendadores:[],
			editingId: '',
			editingType: '',
			filterFields: [
			{
				name: "nome",
				label: "Nome",
				type: "input",
				placeholder:"Nome",
			},
			{
				name: "idade",
				label: "Idade",
				type: "input",
				placeholder:"Idade"
			},
			{
				name: "empresa",
				label: "Empresa",
				type: "input",
				placeholder:"Empresa"
			},
			{
				name: "data_nascimento",
				label: "Data nascimento",
				type: "date",
			},
			{
				name: "cpf",
				label: "CPF",
				type: "input",
				placeholder:"CPF"
			},
			{
				name: "telefone",
				label: "Telefone",
				type: "input",
				placeholder:"Telefone"
			},
			{
				name: "carreira",
				label: "Carreira",
				type: "input",
				placeholder:"Carreira"
			},
		],
		actualPage:'',
		};
	},
	props: {
	},
	methods: {
		async pageData(pageGetSegurados){
			this.actualPage = pageGetSegurados;
			this.loading = true; 
			const seguradosRepo = new SeguradosRepository();
			try {
				const response = await seguradosRepo.getSegurados(this.onlineUser.token,pageGetSegurados,this.filters);
				if (response?.status  === 200) {
					this.seguradoData = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;
					this.getAgendadores();
					this.getEmpresasData();

				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {

					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},
		async onSendFormData(data){
			this.loading = true;
			const seguradoRepo = new SeguradosRepository();
			try {
				const response = await seguradoRepo.createSegurado(this.page,data,this.onlineUser.token);
				if (response?.status === 201) {
					this.resetForm();
					this.pageData(this.actualPage);
					this.mostrarAlerta();
					this.loading = false;
				} else {
					this.error = response?.message;
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}	
		},

		async seguradoBadge(badge){
			this.loading = true;
			badge.tipo =  this.editingType;
			badge.id = this.editingId;
			const badgeRepo = new BadgesRepository();
			try {
				const response = await badgeRepo.createBadge(this.pageBadge,badge,this.onlineUser.token);
				
				if (response?.status === 201) {
					this.getEditData({ id: this.editingId, tipo: this.editingType });
					this.mostrarAlerta();
					this.loading = false;
				} else {
					this.error = response?.message;
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}	

		},

		async deleteBadge(id){
			const badgeRepo = new BadgesRepository();
			try {
				const response = await badgeRepo.deleteBadge(this.pageBadge,this.onlineUser.token,id);
				
				if (response?.status === 200) {
					this.getEditData({ id: this.editingId, tipo: this.editingType });
					this.mostrarAlerta();
					this.loading = false;
				} else {
					this.error = response?.message;
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}	
		},

		async updateAssociatedData(data){
			this.loading = true;
			const associRepo = new GeneralSeguradoEditRepository();
			try {

				const response = await associRepo.updateAssociatedData(this.editingType,this.onlineUser.token,this.editingId,data);
				if (response?.status === 200) {
					this.pageData(this.actualPage);
					this.mostrarAlerta();
					this.loading = false;
				} else {
					this.error = response?.message;
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}

		},

		async getAgendadores(){
			const groupsRepo = new GruposRepository();
			try {
				const response = await groupsRepo.getGroupMembers(this.onlineUser.token,this.agendadoresPage);
				if (response?.status === 200) {
					this.agendadores = response.data
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}	
		},
		async deleteData(id){
			const seguradoRepo = new SeguradosRepository();
			try {
				const response = await seguradoRepo.deleteSegurado(this.page,this.onlineUser.token,id);
				if (response?.status === 204) {
					this.pageData(this.actualPage);
					this.mostrarAlerta();
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async getEditData({ id, tipo = null }){
			let type = '';
			if (tipo === 'dependente') {
				type = 'dependente'
			} else {
				type = 'segurado'
			}

			this.editingId = id;
			this.editingType = type;
			const seguradoRepo = new SeguradosRepository();
			try {
				const response = await seguradoRepo.getSegurado(this.page,this.onlineUser.token,id,this.editingType);
				if (response?.status === 200) {
					this.editFormData = response.data;
					this.isModalOpen = true;
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async getEmpresasData(){
			const empresasRepo = new EmpresasRepository();
			try {
				const response = await empresasRepo.getEmpresasAll(this.onlineUser.token,this.selectBoxPage);
				if (response?.status === 200) {
					this.selectBoxItems = response.data
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async sendImportFile(data){
			this.loading = true;
			const seguradoRepo = new SeguradosRepository();
			const requestPage = data.empresa_id ? this.uploadDataPage : this.uploadUpdatePage;

			try {
				const response = await seguradoRepo.importSeguradoFile(data, this.onlineUser.token, requestPage);

				if (response?.status === 201) {
					this.loading = false;
					this.mostrarAlerta();
				} else {
					this.error = response?.message;
					this.loading = false;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}
		},
		async agendamentoAvulso(data){
			this.loading = true;
			const agendamentosRepo = new AgendamentosRepository();
			try {
				const response = await agendamentosRepo.agendamentoAvulso(this.agendamentoAvulsoPage,this.onlineUser.token,data);
				if (response?.status === 201) {
					this.loading = false;
					this.pageData(this.actualPage);
					this.mostrarAlerta();
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}	
		},
		handleFilters(rawFilters){
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.pageGetSegurados);
		},
		goTo(number){
			this.pageData(this.pageGetSegurados+"?page="+number)
		},
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		},
		async onSaveBulk(data){
			this.loading = true;
			const generalRepo = new GeneralSeguradoEditRepository();

			// 🔁 Ajusta os IDs se for dependente
			if (this.editingType === 'dependente') {
				data.normalized = data.normalized.map(item => {
					if (item.segurado_id) {
						item.dependente_id = item.segurado_id;
						delete item.segurado_id;
					}
					return item;
				});
			}
			try {
				const response = await generalRepo.bulkUpdate(data.normalized,this.onlineUser.token,data.tipo,this.editingType);
				if (response?.status === 200) {
					this.getEditData({ id: this.editingId, tipo: this.editingType });
					this.mostrarAlerta();
					this.loading = false;
				} else {
					this.error = response?.message;
					this.loading = false;
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}
		},

		async removeItem(item){
			this.loading = true;
			const generalRepo = new GeneralSeguradoEditRepository();
			try {
				const response = await generalRepo.deleteRegistry(this.onlineUser.token,item.item.id,item.tipo,this.editingType);
				if (response?.status === 204) {
					this.getEditData({ id: this.editingId, tipo: this.editingType });
					this.mostrarAlerta();
					this.loading = false;
				} else {
					this.error = response?.message;
					this.lading = false;
					this.mostrarAlertaErro(this.error);
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
				this.mostrarAlertaErro(error);
			}
		},

		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6',
			});
		},
		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message,
				confirmButtonColor: '#3085d6', 
			});
		},
	},
	components:{
		Commonlisting,
		CommonLoading,
		EditSegurado,
		FilterComponent
	},
	setup() {
	return {
	}
	}}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
